import React from 'react';
import {Grid} from 'react-bootstrap';
import {Wrapper} from '../system/wrapper';

import Header from '../header';
import Footer from '../system/footer';
import {ContentWrapper} from '../system/content/components';

const Page404Full = (props) => (
  <div>
    <Header/>
    <ContentWrapper>
      <Wrapper>
        <Grid>
          <h2>Помилка 404</h2>
          <h2>Такої сторінки не існує</h2>
        </Grid>
      </Wrapper>
    </ContentWrapper> 
    <Footer/>
  </div>
)

export default Page404Full;



// WEBPACK FOOTER //
// ./src/components/page404-full.js